import { FC, useState } from 'react';
import classnames from 'classnames';
import { Icon, Button, Divider } from 'common-components';
import { PlayArrowIcon, ChevronRight } from '../uiLibraryImports';
import { ChallengeCardProps } from './challengeCardTypes';
import { useTranslationContext } from '../contexts/translationContext';
import styles from './challengeCard.module.scss';

const ChallengeCard: FC<ChallengeCardProps> = (props: ChallengeCardProps) => {
    const { name, score, isTaken, maxScore, level, language, challengeUrl, onShowLeaderboard, imageSrc } = props;
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const { translate } = useTranslationContext();

    return (
        <div onMouseOver={(): void => setIsHovered(true)} onMouseLeave={(): void => setIsHovered(false)}>
            {isHovered && (
                <div className={styles['hovered-wrapper']}>
                    <div
                        className={classnames(styles['hovered-card'], {
                            [styles['taken-hovered-card']]: isTaken
                        })}
                    ></div>
                    <div className={styles['hovered-card-items']}>
                        <div className={styles.button}>
                            <a href={challengeUrl}>
                                {isTaken ? (
                                    <div className={styles['challenge-again']}>
                                        <div className={styles.top}>
                                            <Icon name="retakeChallenge" className={styles['retake-icon']} />
                                            <div className={styles.text}>{translate('ChallengeAgain')}</div>
                                        </div>
                                        <div className={styles.bottom}>
                                            <div className={styles.text}>{translate('ToEarnUpTo')}</div>
                                            <Icon name="devCoin" className={styles['score-icon']} />
                                            <div className={styles.text}>{maxScore.toLocaleString()}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <Button
                                        lowerCase
                                        type="gradient"
                                        text={translate('TakeChallenge')}
                                        startIcon={<PlayArrowIcon />}
                                    />
                                )}
                            </a>
                        </div>
                        <div className={styles.leaderboard} onClick={() => onShowLeaderboard()}>
                            <div>{translate('ChallengeLeaderboard')}</div>
                            <ChevronRight />
                        </div>
                    </div>
                </div>
            )}
            <div
                className={classnames(styles.card, {
                    [styles['taken-card']]: isTaken
                })}
            >
                {isTaken && (
                    <div className={styles['completed-tag']}>
                        <div className={styles.text}>{translate('Taken')}</div>
                        <Divider orientation="vertical" className={styles.divider} color="rgba(255, 255, 255, 0.5)" />
                        <Icon name="devCoin" className={styles['max-score-icon']} />
                        <div className={styles.score}>{score?.toLocaleString()}</div>
                    </div>
                )}
                <div className={styles.top}>
                    <img src={imageSrc} className={styles.img} />
                    <div className={styles['image-overly']}></div>
                    {!isTaken && (
                        <div className={styles.score}>
                            <Icon name="devCoin" className={styles.icon} />
                            <div className={styles['score-text']}>{maxScore.toLocaleString()}</div>
                        </div>
                    )}
                    {language && <div className={styles.language}>{language}</div>}
                </div>
                <div className={styles.bottom}>
                    <div className={styles.title}>
                        <Icon name="challengeIconLearningPanel" className={styles['type-icon']} />
                        <div className={styles.text}>{translate('CHALLENGE')}</div>
                        <div className={styles.level}>({level})</div>
                    </div>
                    <div className={styles.name}>{name}</div>
                </div>
            </div>
        </div>
    );
};

export default ChallengeCard;
